// SiteUp: nomes de rota em que estamos DENTRO de uma conversa aberta.
//
// Usado pra (1) esconder a navegação mobile (bottom nav) e (2) remover o
// padding inferior reservado pra ela — dando tela cheia ao chat sem espaço
// morto embaixo do campo de resposta. Manter os dois critérios sincronizados
// evita divergência entre "a barra sumiu" e "o padding sumiu".
export const CONVERSATION_ROUTE_NAMES = [
  'inbox_conversation',
  'conversation_through_inbox',
  'conversations_through_label',
  'team_conversations_through_label',
  'conversations_through_folders',
  'conversation_through_mentions',
  'conversation_through_unattended',
  'conversation_through_participating',
  'inbox_view_conversation',
];

export const isConversationRouteName = name =>
  CONVERSATION_ROUTE_NAMES.includes(name);
